import { Outlet } from "react-router-dom";
import { BigSideBar, NavBar, SmallSideBar } from "../../components";
import { Wrapper } from "../../components/css/SharedLayoutStyle";
import { isNativeUser } from "../../utils/common";


const SharedLayout = () => {
    const isNative = isNativeUser();
  
    return (
      <Wrapper>
        <main className="dashboard">
          {/* Only render sidebars if NOT native */}
          {!isNative && (
            <>
              <SmallSideBar />
              <BigSideBar />
            </>
          )}
  
          <div>
            {/* Only render the NavBar if NOT native */}
            {!isNative && <NavBar />}
  
            <div className="dashboard-page">
              <Outlet />
            </div>
          </div>
        </main>
      </Wrapper>
    );
  };
  
  export default SharedLayout;